export const SUCCESS = "SUCCESS";
export const ERROR = "ERROR";
export const CLEAR = "CLEAR";
export const APP_LOADING = "APP_LOADING";
export const POPUP_ERROR = "POPUP_ERROR";
